<template>
  <div>
    <div class="action">
      <div>
        <span>用户ID：{{ uid }}</span>
      </div>
      <el-checkbox v-model="hideZero">隐藏余额为0的币种</el-checkbox>
    </div>
    <balance :hideZero="hideZero"></balance>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination';
import Balance from '../balance';

export default {
  name: 'records',
  props: ['uid', 'emails'],
  data() {
    return {
      hideZero: false,
      pagination: {
        page: 1,
        size: 10
      }
    };
  },
  computed: {
    ...mapState('withdrawalAudit', [
      'userRecords',
      'userDetailTotal',
      'userWallet'
    ])
  },
  components: {
    Pagination,
    Balance
  },
  methods: {
    ...mapActions('withdrawalAudit', [
      'getUserRecords',
      'resetUserRecords',
      'getUserWallet'
    ]),
    getList() {
      this.getUserRecords({
        userId: this.uid,
        ...this.pagination
      });
    },
    handleCurrentChange(pagination) {
      this.pagination = pagination;
      this.getList();
    }
  },
  mounted() {
    // this.getList();
    // alert(this.emails)
    this.getUserWallet({ userId: this.uid });
  },
  destroyed() {
    this.resetUserRecords();
  }
};
</script>
<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  span {
    margin-right: 20px;
  }
}
</style>
